export const namespacedPrefix = '[CATING]';
